import { breakpoint, Breakpoint } from "@otto-ec/global-breakpoint";
import { o_global } from "../namespaces";

o_global.breakpoint ||= breakpoint();
o_global.breakpointClass ||= Breakpoint;
o_global.Breakpoint ||= Breakpoint;

/*🤫*/
o_global.device ||= {} as never;
o_global.device.breakpoint ||= window.o_global.breakpoint;
